import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema, VideoCornSchema } from '../base.js';
import { PartialMediaMetadataSchema } from '../base/mediaMetadata.js';
import { VideoSchema } from '../entities/video.js';
export const UpdateVideoBodySchema = z.object({
    description: z.string().optional(),
    labels: z.array(z.string()).optional(),
    order: z.number().optional(),
    metadata: PartialMediaMetadataSchema.optional(),
});
export const UpdateVideoApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        videoId: VideoCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: UpdateVideoBodySchema,
    response: VideoSchema.omit({ s3Key: true }).extend({ signedUrl: z.string().url() }),
};
export const UpdateVideoRequestSchema = UpdateVideoApiSchema.params
    .merge(UpdateVideoApiSchema.body)
    .merge(UpdateVideoApiSchema.headers);
